import { render, staticRenderFns } from "./BB_MyPosts.vue?vue&type=template&id=373986c3&scoped=true&"
import script from "./BB_MyPosts.vue?vue&type=script&lang=js&"
export * from "./BB_MyPosts.vue?vue&type=script&lang=js&"
import style0 from "./BB_MyPosts.vue?vue&type=style&index=0&id=373986c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373986c3",
  null
  
)

export default component.exports